import { ExitIcon, HelpIcon } from '@traceair/webapp-icons';
import { BlackOpacity07, List, ListItem } from '@traceair/tds';
import { stylesheet } from 'typestyle';
import { trackAction } from '../../../libs/analytics/ActionTracking';
import { useAppStore } from '../../../store/appStore';
import { LoginService } from '../../../api_services/LoginService';
import { useUiStore } from '../../../store/uiStore';
import { GlobalUploadState } from '../../main_container/missions/globalUploadState/GlobalUploadState';
import { useGuardUnsavedGcp } from '../../../hooks/useGuardUnsavedGcp';

const css = stylesheet({
  tutorial: {
    padding: '0 12px 5px',
    background: 'none',
  },
  exit: {
    padding: '5px 12px 11px',
    borderTop: `1px solid ${BlackOpacity07}`,
    background: 'none',
    whiteSpace: 'nowrap',
    $nest: {
      '.ta-text-item': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 140,
      },
    },
  },
});

export const SidebarBottomMenu = () => {
  const { user } = useAppStore();
  const { setIsMenuOpen } = useUiStore();
  const withGcpUnsavedChangesGuard = useGuardUnsavedGcp();

  const handleUserGuideClick = () => {
    trackAction('Tutorials sidebar button click', null);
    window.open(TutorialsLink, '_blank');
    setIsMenuOpen(false);
  };

  /**
   * Handles the logout logic: tracks event, calls API, and redirects to sign-in page.
   * This action is guarded to warn about unsaved GCP changes.
   */
  const handleLogout = withGcpUnsavedChangesGuard(async () => {
    trackAction('User logout button click', null);
    const loginService = new LoginService(LoginServiceBaseUrl);

    await loginService.logout();
    setIsMenuOpen(false);
    LoginService.redirectToSigninPage();
  });

  return (
    <>
      <GlobalUploadState />

      <List rounded={true} className={css.tutorial}>
        <ListItem size="s" leftCell={<HelpIcon />} title="User Guide" onClick={handleUserGuideClick} />
      </List>

      <List rounded={true} className={css.exit}>
        <ListItem
          size="s"
          leftCell={<ExitIcon />}
          title={user?.name}
          description={user?.email}
          onClick={handleLogout}
        />
      </List>
    </>
  );
};
